import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagCambioMoneda = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCambioMoneda'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagCambioMoneda' label='Cambiar moneda' />}
    </Field>
  )
}

export default React.memo(FlagCambioMoneda)
